function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.35;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16,20.5c-3.6,0-6.6,3-6.6,6.6s3,6.6,6.6,6.6s6.6-3,6.6-6.6C22.6,23.5,19.6,20.5,16,20.5z M16,33.4 c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3v0C22.3,30.6,19.5,33.4,16,33.4C16,33.4,16,33.4,16,33.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M30.3,15.9h-6.6l-3.3-4.6h-8.9l-3.3,4.6H1.7c-0.9,0-1.7,0.7-1.7,1.7c0,0,0,0,0,0v18.7C0,37.2,0.7,38,1.7,38 c0,0,0,0,0,0h28.5c0.9,0,1.7-0.7,1.7-1.7c0,0,0,0,0,0V17.6c0.1-0.9-0.6-1.6-1.5-1.7C30.4,15.9,30.3,15.9,30.3,15.9z M31.7,36.3 c0,0.8-0.6,1.4-1.3,1.4c0,0,0,0-0.1,0H1.7c-0.8,0-1.4-0.6-1.4-1.3c0,0,0,0,0-0.1V17.6c0-0.8,0.6-1.4,1.3-1.4c0,0,0,0,0.1,0h6.7 l3.3-4.6h8.6l3.3,4.6h6.7c0.8,0,1.4,0.6,1.4,1.3c0,0,0,0,0,0.1V36.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M28.3,0.2c3.6,0,6.5,2.9,6.5,6.5s-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5l0,0C21.8,3.1,24.7,0.2,28.3,0.2 C28.3,0.2,28.3,0.2,28.3,0.2 M28.3,13.4c3.7,0,6.7-3,6.7-6.7C35,3,32,0,28.3,0c-3.7,0-6.7,3-6.7,6.7S24.6,13.4,28.3,13.4 C28.3,13.4,28.3,13.4,28.3,13.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M28.2,10.3h0.2V6.8h3.5V6.6h-3.5V3.2h-0.2v3.5h-3.5v0.2h3.5V10.3z"
}));

var SvgPhotoIcon = function SvgPhotoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 39",
    style: {
      enableBackground: "new 0 0 36 39"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo-icon.9afbcaed.svg";
export { ForwardRef as ReactComponent };